import { compose, lifecycle, withProps } from 'recompose'
import { connect } from 'react-redux'
import withType from 'components/common/hoc/withType'
import withBazaarVoiceRatingFromStore from 'components/common/hoc/withBazaarVoiceInlineRatings/withBazaarVoiceRatingFromStore'
import { tabsConfig } from './helpers'
import { getCurrentBvId, getTireSizeNumber } from '../selectors'
import { getPageLocation } from 'selectors'
import BOTTireSizeLineDetailCartridge from './BOTTireSizeLineDetailCartridge'
import { OPEN_BV_REVIEWS_TAB_AND_SCROLL_DOWN, TIRE_DETAILS_REVIEWS_QUERY } from 'constant'
import { REVIEWS_TAB } from './constants'
import { expandBazaarVoiceReviewTabAndScrollDown } from 'helpers/custom-events'
import qs from 'qs'


const withTireLineProps = withProps(({ bvId, productId }) => ({
  productLineId: productId,
  productId: bvId,
  eventName: OPEN_BV_REVIEWS_TAB_AND_SCROLL_DOWN,
  tabToActivate: REVIEWS_TAB
}))

const withTabConfig = withProps(({
  reviewsCount, bvId, tireSizesCount
}) => ({
  tabsConfig: tabsConfig(reviewsCount, bvId, tireSizesCount)
}))

const mapStateToProps = state => {
  const search = (getPageLocation(state).search || '').slice(1)
  const { tab } = qs.parse(search)
  return {
    searchTab: tab,
    bvId: getCurrentBvId(state),
    tireSizesCount: getTireSizeNumber(state)
  }
}

const withInitialization = lifecycle({
  componentDidMount() {
    const {
      searchTab
    } = this.props

    if (searchTab === TIRE_DETAILS_REVIEWS_QUERY) {
      expandBazaarVoiceReviewTabAndScrollDown()
    }
  }
})


export default compose(
  withType({
    type: 'BOTTireSizeLineDetailCartridge',
    placeholders: ['tireLineSizeInformation']
  }),
  connect(mapStateToProps),
  withInitialization,
  withTireLineProps,
  withBazaarVoiceRatingFromStore,
  withTabConfig
)(BOTTireSizeLineDetailCartridge)
